var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIkonaHfm1Biala({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 126 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,-270,-305.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31009,0,0,2.31009,228.009,717.307)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(24,0,0,24,491.9,243.474)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "439.916px",
    y: "243.474px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial'",
      fontWeight: 700,
      fontSize: 24,
      fill: "white"
    }
  }, "HFM"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59322,0,0,1.59322,1202,1160.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.699C0.035,-0.062 -0.02,-0.557 0.092,-1.012C0.473,-2.569 -0.073,-3.522 -1.528,-4.228C-3.008,-4.944 -4.365,-5.915 -5.767,-6.788C-7.36,-7.78 -7.756,-8.961 -7.063,-10.731C-6.26,-12.782 -5.442,-14.827 -4.601,-16.862C-3.911,-18.535 -2.765,-19.136 -1.006,-18.77C0.97,-18.359 2.948,-17.954 4.91,-17.483C5.594,-17.318 5.995,-17.499 6.401,-18.038C7.753,-19.834 9.298,-21.456 11.05,-22.866C11.598,-23.307 11.672,-23.748 11.503,-24.397C10.983,-26.385 10.512,-28.386 10.047,-30.388C9.648,-32.108 10.198,-33.248 11.795,-33.954C13.876,-34.874 15.967,-35.775 18.068,-36.646C19.706,-37.325 20.901,-36.952 21.871,-35.482C22.963,-33.828 24.053,-32.17 25.081,-30.476C25.486,-29.811 25.956,-29.59 26.705,-29.707C28.93,-30.055 31.171,-30.014 33.406,-29.843C34.013,-29.797 34.351,-29.987 34.651,-30.49C35.705,-32.255 36.781,-34.006 37.87,-35.751C38.895,-37.394 40.021,-37.782 41.784,-37.09C43.868,-36.272 45.947,-35.44 48.015,-34.582C49.635,-33.909 50.226,-32.776 49.874,-31.062C49.467,-29.085 49.068,-27.105 48.585,-25.146C48.403,-24.408 48.615,-23.994 49.179,-23.568C51.002,-22.19 52.657,-20.627 54.079,-18.836C54.508,-18.295 54.949,-18.17 55.605,-18.34C57.558,-18.846 59.523,-19.311 61.489,-19.769C63.307,-20.193 64.446,-19.613 65.191,-17.898C66.054,-15.912 66.915,-13.925 67.753,-11.927C68.505,-10.134 68.133,-8.92 66.522,-7.861C64.897,-6.792 63.276,-5.712 61.615,-4.702C60.913,-4.275 60.691,-3.776 60.808,-2.983C61.13,-0.792 61.091,1.413 60.884,3.609C60.827,4.214 60.987,4.559 61.5,4.86C63.272,5.902 65.03,6.968 66.781,8.045C68.431,9.06 68.81,10.169 68.111,11.956C67.308,14.007 66.489,16.052 65.647,18.087C64.954,19.763 63.819,20.359 62.05,19.995C60.037,19.582 58.023,19.168 56.024,18.693C55.38,18.539 55.011,18.71 54.63,19.213C53.275,21.008 51.716,22.617 49.957,24.018C49.38,24.478 49.266,24.935 49.449,25.634C49.971,27.622 50.441,29.623 50.894,31.628C51.263,33.264 50.679,34.416 49.138,35.095C47.056,36.013 44.965,36.911 42.863,37.782C41.178,38.481 40.021,38.099 38.997,36.543C37.928,34.918 36.849,33.297 35.835,31.637C35.398,30.922 34.951,30.651 34.061,30.78C32.098,31.065 30.11,31.024 28.126,30.917C27.449,30.88 27.169,30.603 27.053,29.945C26.661,27.734 26.016,25.592 25.141,23.521C25.018,23.231 24.698,22.897 24.929,22.61C25.162,22.321 25.548,22.57 25.858,22.63C33.839,24.166 40.891,22.222 46.568,16.438C52.998,9.887 54.837,1.924 51.859,-6.736C48.865,-15.442 42.487,-20.591 33.33,-21.774C17.666,-23.798 4.937,-9.362 8.69,5.955C8.778,6.317 9.138,6.77 8.776,7.07C8.487,7.309 8.086,6.967 7.753,6.843C5.68,6.072 3.556,5.497 1.362,5.229C0.583,5.134 0.285,4.764 0.24,4.042C0.165,2.834 0.068,1.627 0,0.699",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59322,0,0,1.59322,1172.15,1216.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.145C-0.081,8.407 6.93,15.543 15.522,15.654C24.158,15.765 31.363,8.756 31.456,0.155C31.55,-8.526 24.59,-15.708 15.99,-15.806C7.208,-15.905 0.084,-8.928 0,-0.145M-5.746,16.138C-5.756,15.594 -5.512,15.147 -5.21,14.722C-4.465,13.675 -3.741,12.612 -2.968,11.587C-2.592,11.088 -2.514,10.667 -2.843,10.095C-3.557,8.851 -4.124,7.533 -4.502,6.146C-4.659,5.569 -4.98,5.317 -5.567,5.235C-6.802,5.063 -8.029,4.83 -9.258,4.617C-10.934,4.325 -11.469,3.708 -11.479,2.036C-11.488,0.678 -11.487,-0.681 -11.477,-2.039C-11.465,-3.596 -10.943,-4.226 -9.399,-4.51C-8.173,-4.736 -6.942,-4.94 -5.708,-5.121C-5.092,-5.211 -4.752,-5.483 -4.584,-6.118C-4.217,-7.504 -3.67,-8.832 -2.965,-10.084C-2.695,-10.563 -2.719,-10.942 -3.048,-11.387C-3.878,-12.508 -4.685,-13.647 -5.466,-14.802C-6.213,-15.905 -6.137,-16.693 -5.202,-17.656C-4.154,-18.737 -3.09,-19.802 -2.01,-20.85C-1.04,-21.791 -0.192,-21.844 0.944,-21.046C1.995,-20.308 3.04,-19.559 4.058,-18.776C4.555,-18.393 4.972,-18.326 5.545,-18.656C6.755,-19.353 8.039,-19.914 9.39,-20.279C10.058,-20.46 10.334,-20.834 10.423,-21.5C10.588,-22.735 10.818,-23.963 11.038,-25.191C11.313,-26.718 11.961,-27.272 13.503,-27.289C14.898,-27.304 16.293,-27.302 17.688,-27.288C19.23,-27.272 19.858,-26.735 20.14,-25.188C20.35,-24.033 20.552,-22.875 20.716,-21.713C20.818,-20.988 21.089,-20.541 21.881,-20.356C23.205,-20.045 24.474,-19.521 25.639,-18.819C26.329,-18.404 26.836,-18.526 27.427,-18.973C28.451,-19.748 29.505,-20.484 30.57,-21.203C31.589,-21.892 32.468,-21.818 33.349,-20.965C34.456,-19.892 35.546,-18.8 36.618,-17.692C37.534,-16.745 37.592,-15.94 36.834,-14.83C36.069,-13.709 35.282,-12.601 34.479,-11.506C34.162,-11.073 34.086,-10.693 34.373,-10.202C35.116,-8.928 35.647,-7.556 36.065,-6.146C36.234,-5.578 36.526,-5.305 37.126,-5.223C38.434,-5.045 39.734,-4.805 41.034,-4.572C42.375,-4.332 42.947,-3.683 42.97,-2.326C42.996,-0.821 42.995,0.685 42.971,2.19C42.95,3.558 42.393,4.183 41.034,4.424C39.77,4.649 38.508,4.904 37.235,5.061C36.536,5.147 36.223,5.468 36.045,6.12C35.686,7.434 35.178,8.702 34.481,9.871C34.09,10.524 34.203,10.994 34.63,11.553C35.408,12.574 36.146,13.628 36.87,14.689C37.616,15.782 37.553,16.599 36.632,17.552C35.561,18.661 34.469,19.751 33.359,20.82C32.48,21.666 31.592,21.733 30.576,21.042C29.483,20.299 28.4,19.54 27.346,18.743C26.811,18.338 26.353,18.268 25.75,18.618C24.541,19.32 23.246,19.852 21.896,20.219C21.269,20.389 20.999,20.735 20.909,21.358C20.721,22.666 20.494,23.968 20.252,25.266C20.014,26.548 19.357,27.115 18.068,27.135C16.527,27.159 14.985,27.158 13.443,27.135C12.131,27.115 11.485,26.566 11.246,25.281C11.005,23.983 10.772,22.681 10.593,21.373C10.508,20.744 10.254,20.406 9.626,20.225C8.285,19.838 6.981,19.328 5.773,18.619C5.237,18.305 4.845,18.411 4.382,18.756C3.264,19.589 2.121,20.39 0.974,21.183C0.072,21.807 -0.834,21.784 -1.634,21.015C-2.824,19.87 -3.98,18.689 -5.145,17.517C-5.521,17.139 -5.723,16.675 -5.746,16.138",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00184882,1.59322,1.59322,0.00184882,1250.83,1136.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.468,-15.548C6.773,-15.518 -0.068,-8.609 -0.053,0.127C-0.039,8.569 6.949,15.479 15.468,15.475C24.108,15.472 31.066,8.452 31.009,-0.205C30.955,-8.663 23.951,-15.577 15.468,-15.548",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30928,0,0,1.30928,1040.97,249.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.584,811L140,811L140,764.854M140,653.264L140,609L249,609M292,652L292,766.584",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30928,0,0,1.30928,1040.97,249.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,652L249,652L249,609",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30928,0,0,1.30928,1040.97,249.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249,609L292,652",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.969786,0,0,0.969786,1138.89,462.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,789L274,789",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.58px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.969786,0,0,0.969786,1139.37,462.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.58px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.969786,0,0,1.84259,1168.98,-225.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.7px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.969786,0,0,2.32749,1194.77,-608.547)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.4px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.969786,0,0,2.74773,1221.75,-940.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.22px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59322,0,0,1.59322,82.5832,75.464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 841.5,
    cy: 775.5,
    r: 36.5,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.64px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.4696,0,0,12.4696,-9314.96,-8157.3)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10,0,0,10,863.692,761.904)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "858.692px",
    y: "761.904px",
    style: {
      fontFamily: "'ArialMT', 'Arial'",
      fontSize: 10,
      fill: "white"
    }
  }, "s"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.761979,0,0,0.761979,-339.211,-186.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59322,0,0,1.59322,70.7627,76.2606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.919,796.207L848.919,801M848.919,747L848.919,753.799",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "5.26px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaHfm1Biala);
export default __webpack_public_path__ + "static/media/IkonaHFM_1_biala.4f89e564f4fab4d50e9c1484889f768f.svg";
export { ForwardRef as ReactComponent };